module.exports = __webpack_public_path__ + "img/map-position-dot.96d2e05b.svg";